import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function TranslationStatusRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.TranslationStatus', {
		url: '/admin/translation_status',
		controllerAs: 'vm',
		controller: TranslationStatusCtrl,
		templateUrl: '/ng/hub/Translation/Status/TranslationStatusCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Translation/Status/TranslationStatusCtrl.css'),
			$title: () => 'PostsTranslate page',
		},
	});
}

export class TranslationStatusCtrl {
	constructor(Api, Cfg, Identity, $scope, Logger) {
		'ngInject';
		this.name = 'TranslateStatus';
		this.Api = Api;
		this.Cfg = Cfg;
		this.Identity = Identity;
		this.Logger = Logger;
		this.currHubId = this.Identity.currentClient().id;
		this.getAiTranslateSetting();
		this.getHubTranslationStats();
		this.settingsModelKey = 'hub_value';
		this.translatedStats = [];
		this.settings = [];
		this.translateEnabled = this.Cfg.read('AI.translate') == 1;
	}

	getAiTranslateSetting() {
		this.Api.get('/config/search?code=Ai.translate').then(setting => {
			this.settings = setting;
		});
	}
	getHubTranslationStats() {
		this.Api.get('/posts/translations').then(data => {
			this.translatedStats = this.formatTranslationData(data);
		});
	}

	formatTranslationData(translationData) {
		//move the unsup row to the bottom of the table this will end up being second from the bottom
		// if checked row exists
		const unsupportedIndex = translationData.findIndex(row => row.translated_from.toLowerCase() === 'unsup');
		if (unsupportedIndex >= 0) {
			const unsupportedRow = translationData.splice(unsupportedIndex, 1);
			unsupportedRow[0].translated_from = 'Unsupported language';
			translationData.splice(translationData.length - 1, 0, ...unsupportedRow);
		}
		//move the checked row to the bottom of the table
		const checkedIndex = translationData.findIndex(row => row.translated_from.toLowerCase() === 'checked');
		if (checkedIndex >= 0) {
			const checkedRow = translationData.splice(checkedIndex, 1);
			checkedRow[0].translated_from = 'Checked (No translation needed)';
			translationData.splice(translationData.length - 1, 0, ...checkedRow);
		}
		return translationData;
	}

	translateHubPosts() {
		this.pendingJob = true;
		this.Api.submitJob('post', `/v2/posts/translate`)
			.then(response => {
				if (response.data.success === true) {
					response.onJobComplete(() => {
						this.pendingJob = false;
						this.getHubTranslationStats();
					});
				}
			})
			.catch(error => {
				this.Logger.write('POST_MASS_DELETE_DEBUG', 'Error translating posts for hub:', this.currHubId);
			});
	}
	saveSetting(setting) {
		setting.isSaving = true;
		this.Cfg.write(setting.code, String(setting[this.settingsModelKey]), setting.scope).then(() => {
			setting.isSaving = false;
			this.translateEnabled = this.Cfg.read('AI.translate') == 1;
		});
	}
}
